import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-relatorio-laudo-resumo-lista',
  templateUrl: './relatorio-laudo-resumo-lista.component.html',
  styleUrls: ['./relatorio-laudo-resumo-lista.component.scss']
})
export class RelatorioLaudoResumoListaComponent implements OnInit {

  @Input() template;

  elementsSuccess = [];
  elementsWarning = [];
  elementsDanger = [];
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.template && this.template.elements) {
      this.elementsSuccess = this.template.elements.filter( e => e.status < 3 );
      this.elementsWarning = this.template.elements.filter( e => e.status > 2 && e.status < 5 );
      this.elementsDanger = this.template.elements.filter( e => e.status > 4 );
    }
  }

}
